import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function useTin(form: any, updateFormValues: any) {
  const [tinError, setTinError] = useState<any>(null);
  const [tinUser, setTinUser] = useState<any>(null);
  const [loader, setLoader] = useState<any>(false);
  const [success, setSuccess] = useState<any>(false);

  useEffect(() => {
    setTinError(null);
    if (form?.tin) {
      if (form?.tin?.length == 10) {
        setLoader(true);
        setSuccess(false);
        setTinUser(null);

        const fetchTin = async () => {
          try {
            // const TIN_SERVICE_URL = `https://iras.go.ug/api/services/tin-data/validate-tin/`;
            const TIN_SERVICE_URL =
              "https://eservices.nema.go.ug/api/services/validate-tin";

            const response: any = await axios.get(TIN_SERVICE_URL, {
              headers: {
                "Content-Type": "application/json",
              },
              params: {
                tin: form?.tin,
              },
            });
            setLoader(false);

            // Check if response has valid data with taxPayerName
            if (response?.data && response.data.taxPayerName) {
              setTinUser(response?.data);
            } else {
              // Response received but no valid data found
              setTinUser(null);
              setSuccess(false);
              toast.error("TIN data not found");
              updateFormValues({
                taxpayer_name: "",
                email: "",
              });
            }
          } catch (error) {
            setLoader(false);
            setSuccess(false);
            toast.error("TIN data not found");
            updateFormValues({
              taxpayer_name: "",
              email: "",
            });
          }
        };
        fetchTin();
      } else {
        setLoader(false);
        setSuccess(false);
        updateFormValues({
          taxpayer_name: "",
          email: "",
        });
      }
    }
  }, [form?.tin]);

  useEffect(() => {
    if (tinUser) {
      updateFormValues({
        taxpayer_name: tinUser?.taxPayerName,
        email: tinUser?.taxPayerEmail,
      });
      setTinError(null);
      // Set success to true only after values are updated
      setSuccess(true);
    }
    // Don't set error here - it's handled in the API call itself
  }, [tinUser]);

  return { loader, tinError, success };
}
